<template>
    <div id="frameBed">
        <component :is="$route.params.id" />
    </div>
</template>

<script>
import { coreComponents } from '@/config/componentLoader';
import GraphFrame from '@/components/frameComp/GraphFrame.vue';

export default {
  components: {
    ...coreComponents,
    GraphFrame,
  },

  data() {
    return {
      search: '',
      componentId: null,
      frameWidget: ['WikiDataCard', 'Videos', 'Detail', 'GraphExplore', 'Glossary'],
      frameDetail: {
        WikiDataCard: {
          type: 'search',
          dispatchName: 'wikiWordFetch',
          payload: (word) => (word),
        },
        Videos: {
          type: 'search',
          dispatchName: 'youtubeSearchByKeyword',
          payload: (word) => (word),
        },
        GraphExplore: {
          type: 'fetch',
          dispatchName: 'gmodule/getGraph',
          payload: (id) => (id),
        },
        GraphFrame: {
          type: 'fetch',
          dispatchName: 'gmodule/getGraph',
          payload: (id) => (id),
        },
      },
    };
  },

  methods: {

  },
  async mounted() {
    this.componentId = this.$route.params.id;
    this.dispatcher = this.frameDetail[this.componentId].dispatchName;
    this.payload = this.frameDetail[this.componentId].payload(this.$route.params.search);
    await this.$store.dispatch(this.dispatcher, this.payload);
  },
};
</script>

<style lang="scss" scoped>
#frameBed {
    width: 100%;
    height: 100%;
    // min-height: 100vh;
}
</style>
